/** Valores por defecto — Hardware → Balanza (v1, solo estructura; sin lógica en parser/cajero). */

export const BALANZA_MODO_OPTIONS = [
  { value: 'sin_balanza', label: 'Sin balanza' },
  { value: 'etiquetas', label: 'Etiquetas' },
  { value: 'peso_tiempo_real', label: 'Peso en tiempo real' }
];

export const BALANZA_MARCA_OPTIONS = [
  { value: 'kretz', label: 'Kretz' },
  { value: 'systel', label: 'Systel' },
  { value: 'toledo', label: 'Toledo' },
  { value: 'personalizado', label: 'Personalizado' }
];

export const DEFAULT_HARDWARE_BALANZA = {
  modo: 'sin_balanza',
  marca: 'kretz',
  personalizado: {
    prefijo: '20',
    longitud: '13',
    plu: '4',
    separador: '1',
    peso: '5',
    digitoVerificador: '1'
  }
};

export function mergeHardwareBalanzaConfig(source = {}) {
  const personalizado = {
    ...DEFAULT_HARDWARE_BALANZA.personalizado,
    ...(source.personalizado || {})
  };
  return {
    ...DEFAULT_HARDWARE_BALANZA,
    ...source,
    personalizado
  };
}
